import {set, get } from "@/utils/localStorage";
export default {
    data() {
        return {
            recentGoods: ""
        }
    },
    mounted() {
        // 最近查看 
        this.recentGoods = get("recent-goods");
    },
    methods: {

    }
}